var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isManager)?_c('ManagerView'):_vm._e(),_vm._v(" "),(_vm.isMember)?_c('MemberView'):_c('RequiresMember',{attrs:{"page":"Assigned Locations"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }